// Requires: src/checkout-state.js

(function ($, CheckoutState) {
    'use strict';

    var $addressSelector = $('[data-checkout-select-address]');
    var $addressSave = $('[data-save-address]');
    var $clearForm = $('[data-address-form-back]');

    $addressSelector.on('change', updateCurrentAddress);
    $addressSave.on('click', saveNewAddress);
    $clearForm.on('click', clearForm);

    function updateCurrentAddress(event) {
        var $this = $(event.target);
        var type = $this.attr('data-checkout-select-type');
        var displayurl = $this.attr('data-checkout-select-address');
        var dataurl = $this.attr('data-checkout-select-address-info');
        var addressid = $this.val();
        if (addressid !== '') {
            $('[data-checkout-current-address="' + type + '"]').addClass('loading');
            $.post(dataurl, { addressID: addressid },
                function (data) {
                    updateAddress(addressid, data.IsDefault, displayurl, type);
                });
        }
    }
    function updateAddress(addressId, isdefault, url, type) {
        if (addressId !== '') {
            $.post(url, { addressID: addressId },
                function (data) {
                    updateAddressDisplay(type, data, isdefault);
                    // Vat Calculation For DevliveryAddress
                    refreshVatArea();
                });
        }
    }

    function updateAddressSuccess(type, data) {
        if (type === 'delivery') {
            CheckoutState.state.set(CheckoutState.state.type.currentAddress, data);
        } else {
            CheckoutState.state.set(CheckoutState.state.type.currentAddressBilling, data);
        }

        $('[data-checkout-current-address="' + type + '"]').removeClass('loading');
    }
    function updateAddressDisplay(type, data, isdefault) {

        var $addrestodisplay = $('#' + type + 'addressfordisplay');
        var $defaddrest = $('#' + type + 'defaddress');
        $addrestodisplay.html(data);
        if (isdefault) {
            $defaddrest.show();
        } else {
            $defaddrest.hide();
        }

        $('[data-checkout-current-address="' + type + '"]').removeClass('loading');
    }

    function saveNewAddress(event) {
        var $this = $(event.target);
        var REQUEST_URL = $this.attr('data-save-address');
        var $addressForm,
            formData;

        //force this to run after the validation script by using a timeout
        setTimeout(function () {
            if (stepValid($this)) {
                $addressForm = $this.closest('[data-validated]');
                formData = $addressForm.find('input').serialize();
                disableAddressSelect();
                $.post(REQUEST_URL, { newAddress: formData })
                    .done(updateAddressSelect)
                    .fail(enableAddressSelect);
            }
        }, 0);
    }

    function stepValid($trigger) {
        var valid = true;
        var $triggerValidationGroup = $trigger.closest('[data-validated]');
        var $validationGroupErrors = $triggerValidationGroup.find('.has-error');

        if ($validationGroupErrors.length > 0) {
            valid = false;
        }
        return valid;
    }

    function updateAddressSelect(data) {
        CheckoutState.state.set(CheckoutState.state.type.addressSelect, data);
        enableAddressSelect();
    }

    function disableAddressSelect() {
        $('[data-checkout-select-type="billing"]')
            .attr('disabled', 'disabled')
            .closest('.form-select-wrapper')
            .addClass('form-select-wrapper__loading');
    }

    function enableAddressSelect() {
        $('[data-checkout-select-type="billing"]')
            .removeAttr('disabled')
            .closest('.form-select-wrapper')
            .removeClass('form-select-wrapper__loading');
    }

    function clearForm(event) {
        var $this = $(event.target);
        var $validationGroup = $this.closest('[data-validated]');
        $validationGroup.find('input').val('');
        $validationGroup.find('.help-block').html('');
        $validationGroup.find('.has-success').removeClass('has-success');
        $validationGroup.find('.has-error').removeClass('has-error');
    }

    function refreshVatArea() {
        var $url = '/api/sitecore/OnlineBasket/VatCalculationForDevliveryAddress';
        var $postCode = $jq("#deliveryaddressfordisplay").find(".postal-code").text();
        $.ajax({
            url: $url,
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                postcode: $postCode
            })
        }).done(function (data) {
            $(".basket--summary").replaceWith(data);
        }).fail(function (error) {
            console.log(error.statusText);
        });
    }

})($jq, window.BOL.Checkout.State);
